import { toLabelSelectItem } from '../../Label'

export function getLabelsValueWithCreatedLabel(labelsValue, createdLabel) {
  return [...labelsValue, toLabelSelectItem(createdLabel)]
}
